export default {
    // 中
    zhCN: {
        have: '共有',
        NoticeWaitingToBeRead: '条待阅通知',
        title: '标题',
        publishing_department: '发布部门',
        status: '状态',
        release_Date: '发布日期',
        bulletin_id: '公告ID',
        publisher: '发布人',
        information_detail: '公告信息',
        notification_Title: '通知标题',
        publish_Objects: '发布对象',
        publish_Mode: '发布模式',
        publish_Content: '发布内容',
        bulletin_type: '公告分类',
        viewing_rate_statements_export: '查看率报表导出',
        report_export: '报表导出',
        related_announcements: '关联公告信息',
        related_announcements_notification: '关联公告通知',
        link_to_announcement: '链接',
        forwarding_records: '转发记录',
        vehicle_condition: '车况',
        Extreme: '极端',
        road_condition: '路况',
        climate: '气候',
        frequency: '频率',
        organization_code: '组织CODE',
        organization_name: '组织名称',
        email_notification: '是否邮件通知',
        required_are_mis: '存在必填项未填！',
        select_publish_Objects: '选择发布对象',
        isPinned: '是否置顶',
        deftem: '默认模板',
        newtempset: '新模板设置',
        emailtemp: '邮件模板',
    },
    // 英
    enUS: {
        have: 'Have',
        NoticeWaitingToBeRead: 'Notice waiting to be read',
        title: 'Title',
        publishing_department: 'Publishing department',
        status: 'Status',
        release_Date: 'Release date',
        bulletin_id: 'Bulletin ID',
        publisher: 'Publisher',
        information_detail: 'Information detail',
        notification_Title: 'Notification title',
        publish_Objects: 'Release to',
        publish_Mode: 'Release mode',
        publish_Content: 'Release content',
        bulletin_type: 'Bulletin type',
        viewing_rate_statements_export: 'View Rate Report Export',
        report_export: 'report Export',
        related_announcements: 'Related announcement information',
        related_announcements_notification: 'Related announcements notification',
        link_to_announcement: 'Announcement',
        forwarding_records: 'Forwarding records',
        vehicle_condition: 'Vehicle Condition',
        Extreme: 'Extreme',
        road_condition: 'Road Condition',
        climate: 'Climate',
        frequency: 'Frequency',
        organization_code: 'Organization code',
        organization_name: 'Organization name',
        email_notification: 'Email Notification',
        required_are_mis: 'Required fields are missing!',
        select_publish_Objects: 'Select publish target',
        isPinned: 'isPinned',
        deftem: 'Default Temp',
        newtempset: 'New Temp. Set.',
        emailtemp: 'Email Temp.',
    },
    // 德
    deDE: {
        have: 'haben',
        NoticeWaitingToBeRead: 'Benachrichtigungen wartend auf Lektüre',
        title: 'Titel',
        publishing_department: 'Herausgebende Abteilung',
        status: 'Status',
        release_Date: 'Veröffentlichungsdatum',
        bulletin_id: 'Bulletin-ID',
        publisher: 'Veröffentlicher',
        information_detail: 'Information Detail',
        notification_Title: 'Benachrichtigungstitel',
        publish_Objects: 'Freigabe an',
        publish_Mode: 'Freigabemodus',
        publish_Content: 'Freigegebener Inhalt',
        bulletin_type: 'Ausgefallene typen',
        viewing_rate_statements_export: 'Export des Anzeigeraten-Berichts',
        report_export: 'Exportbericht',
        related_announcements: 'Verwandte Ankündigungsinformationen',
        related_announcements_notification: 'Verwandte Ankündigungsbenachrichtigung',
        link_to_announcement: 'Ankündigung',
        forwarding_records: 'Weiterleitung von Datensätzen',
        vehicle_condition: 'Fahrzeugzustand',
        Extreme: 'Extrem',
        road_condition: 'Straßenzustand',
        climate: 'Klima',
        frequency: 'Frequenz',
        organization_code: 'Organisationscode',
        organization_name: 'Organisationsname',
        email_notification: 'E-Mail-Benachrichtigung',
        required_are_mis: 'Es fehlen erforderliche Felder!',
        select_publish_Objects: 'Wählen Sie das Veröffentlichungsziel',
        isPinned: 'istAngeheftet',
        deftem: 'Standardvorlage',
        newtempset: 'Neue Vlg. Einst.',
        emailtemp: 'E-Mail Vorl.',
    },
    // 法
    frFR: {
        have: 'Avoir',
        NoticeWaitingToBeRead: 'Notification en attente de lecture',
        title: 'Titre',
        publishing_department: 'Département',
        status: 'Statut',
        release_Date: 'Date de sortie',
        bulletin_id: 'ID du bulletin',
        publisher: 'Rédacteur',
        information_detail: 'Détails',
        notification_Title: 'Titre de la notification',
        publish_Objects: 'A destination de',
        publish_Mode: 'Mode de communication',
        publish_Content: 'Contenu',
        bulletin_type: 'Types d’annonces',
        viewing_rate_statements_export: 'Exportation du Rapport de Taux de Visualisation',
        report_export: 'Rapport d\'exportation',
        related_announcements: 'Informations sur l\'annonce connexe',
        related_announcements_notification: 'Notification d\'annonce associée',
        link_to_announcement: 'Annonce',
        forwarding_records: 'Transfert des enregistrements',
        vehicle_condition: 'État du véhicule',
        Extreme: 'Extrême',
        road_condition: 'État de la route',
        climate: 'Climat',
        frequency: 'Fréquence',
        organization_code: 'Code organisation',
        organization_name: 'Nom organisation',
        email_notification: 'Notification par e-mail',
        required_are_mis: 'Des champs obligatoires sont manquants!',
        select_publish_Objects: 'Sélectionner l\'objet de publication',
        isPinned: 'estEpingle',
        deftem: 'Modèle par défaut',
        newtempset: 'Nouv. Config.',
        emailtemp: 'Mod. Email',
    },
    // 意大利
    itIT: {
        have: 'Hai',
        NoticeWaitingToBeRead: 'notifiche in attesa di lettura',
        title: 'Titolo',
        publishing_department: 'Reparto Pubblicazione',
        status: 'Stato',
        release_Date: 'Data di Rilascio',
        bulletin_id: 'ID Bollettino',
        publisher: 'Pubblicatore',
        information_detail: 'Dettaglio Informazione',
        notification_Title: 'Titolo Notifica',
        publish_Objects: 'Destinatari',
        publish_Mode: 'Modalità di Rilascio',
        publish_Content: 'Contenuto Rilascio',
        bulletin_type: 'Tipo di notifica',
        viewing_rate_statements_export: 'Esportazione del Rapporto sul Tasso di Visualizzazione',
        report_export: 'Esporta rapporto',
        related_announcements: 'Informazioni sull\'annuncio correlato',
        related_announcements_notification: 'Notifica di annuncio correlata',
        link_to_announcement: 'Annuncio',
        forwarding_records: 'Invio dei record',
        vehicle_condition: 'Condizione del veicolo',
        Extreme: 'Estremo',
        road_condition: 'Condizione stradale',
        climate: 'Clima',
        frequency: 'Frequenza',
        organization_code: 'Codice Organizzazione',
        organization_name: 'Nome Organizzazione',
        email_notification: 'Notifica via e-mail',
        required_are_mis: 'Mancano dei campi obbligatori!',
        select_publish_Objects: 'Selezionare l\'oggetto di pubblicazione',
        isPinned: 'eFissato',
        deftem: 'Modello predefinito',
        newtempset: 'Nuove Imp.',
        emailtemp: 'Mod. Email',
    },
    // 荷兰
    nlNL: {
        have: 'Hebben',
        NoticeWaitingToBeRead: 'Kennisgevingen die wachten om te worden gelezen',
        title: 'Titel',
        publishing_department: 'Uitgevende afdeling',
        status: 'Status',
        release_Date: 'Uitgiftedatum',
        bulletin_id: 'Bulletin ID',
        publisher: 'Uitgever',
        information_detail: 'Informatiedetails',
        notification_Title: 'Meldingstitel',
        publish_Objects: 'Uitgeven aan',
        publish_Mode: 'Uitgiftetype',
        publish_Content: 'Uitgeefinhoud',
        bulletin_type: 'Soort aankondiging',
        viewing_rate_statements_export: 'Exporteer Rapport van Weergavesnelheid',
        report_export: 'Exportverslag',
        related_announcements: 'Gerelateerde aankondigingsinformatie',
        related_announcements_notification: 'Gerelateerde aankondigingsmelding',
        link_to_announcement: 'Aankondiging',
        forwarding_records: 'Doorsturen van records',
        vehicle_condition: 'Voertuigconditie',
        Extreme: 'Extreem',
        road_condition: 'Wegconditie',
        climate: 'Klimaat',
        frequency: 'Frequentie',
        organization_code: 'Organisatie code',
        organization_name: 'Organisatie naam',
        email_notification: 'E-mailmelding',
        required_are_mis: 'Vereiste velden ontbreken!',
        select_publish_Objects: 'Selecteer publicatiedoel',
        isPinned: 'isVastgepind',
        deftem: 'Standaard sjabloon',
        newtempset: 'Nieuwe Inst.',
        emailtemp: 'E-mail Sjab.',
    },
    // 越南
    viVN: {
        have: 'Tổng cộng',
        NoticeWaitingToBeRead: 'thông báo đang chờ đọc',
        title: 'Tiêu đề',
        publishing_department: 'Bộ phận xuất bản',
        status: 'Trạng thái',
        release_Date: 'Ngày phát hành',
        bulletin_id: 'Mã số bảng thông báo',
        publisher: 'Nhà xuất bản',
        information_detail: 'Thông tin chi tiết',
        notification_Title: 'Tiêu đề thông báo',
        publish_Objects: 'Phát hành tới',
        publish_Mode: 'Chế độ phát hành',
        publish_Content: 'Nội dung phát hành',
        bulletin_type: 'Loại thông báo',
        viewing_rate_statements_export: 'Xuất Báo cáo Tỷ lệ Xem',
        report_export: 'Báo cáo Xuất khẩu',
        related_announcements: 'Thông tin thông báo liên quan',
        related_announcements_notification: 'Thông báo thông báo liên quan',
        link_to_announcement: 'Thông báo',
        forwarding_records: 'Chuyển tiếp hồ sơ',
        vehicle_condition: 'Tình trạng xe',
        Extreme: 'Cực kỳ',
        road_condition: 'Tình trạng đường',
        climate: 'Khí hậu',
        frequency: 'Tần suất',
        organization_code: 'Mã tổ chức',
        organization_name: 'Tên tổ chức',
        email_notification: 'Thông báo qua email',
        required_are_mis: 'Có trường bắt buộc chưa được điền!',
        select_publish_Objects: 'Chọn đối tượng phát hành',
        isPinned: 'coGhim',
        deftem: 'Mẫu mặc định',
        newtempset: 'Cài mới',
        emailtemp: 'Mẫu Email',
    },
    // 西班牙
    esES: {
        have: 'Total',
        NoticeWaitingToBeRead: 'Número de notificaciones pendientes de lectura',
        title: 'Título',
        publishing_department: 'Departamento de publicación',
        status: 'Estado',
        release_Date: 'Fecha de publicación',
        bulletin_id: 'ID del anuncio',
        publisher: 'Persona que publica',
        information_detail: 'Información del anuncio',
        notification_Title: 'Título de la notificación',
        publish_Objects: 'Destinatarios de la publicación',
        publish_Mode: 'Modo de publicación',
        publish_Content: 'Contenido de la publicación',
        bulletin_type: 'Categoría del anuncio',
        viewing_rate_statements_export: 'Exportar Informe de Tasa de Visualización',
        report_export: 'Informe de exportación',
        related_announcements: 'Información de anuncio relacionada',
        related_announcements_notification: 'Notificación de anuncio relacionada',
        link_to_announcement: 'Anuncio',
        forwarding_records: 'Registro de reenvío',
        vehicle_condition: 'Estado del vehículo',
        Extreme: 'Extremo',
        road_condition: 'Estado de la carretera',
        climate: 'Clima',
        frequency: 'Frecuencia',
        organization_code: 'Código de la organización',
        organization_name: 'Nombre de la organización',
        email_notification: 'Notificación por correo electrónico',
        required_are_mis: '¡Faltan campos obligatorios!',
        select_publish_Objects: 'Seleccionar el objetivo de publicación',
        isPinned: 'estaAnclado',
        deftem: 'Plantilla predeterminada',
        newtempset: 'Nuevas Conf.',
        emailtemp: 'Plant. Email',
    },
    // 葡萄牙
    ptBR: {
        have: 'Têm no total',
        NoticeWaitingToBeRead: 'notificações para ler',
        title: 'Título',
        publishing_department: 'Departamento de Publicação',
        status: 'Estado',
        release_Date: 'Data de publicação',
        bulletin_id: 'ID do aviso',
        publisher: 'Editor',
        information_detail: 'Detalhes do aviso',
        notification_Title: 'Título da notificação',
        publish_Objects: 'Objetos de publicação',
        publish_Mode: 'Modo de publicação',
        publish_Content: 'Conteúdo de publicação',
        bulletin_type: 'Classificação do aviso',
        viewing_rate_statements_export: 'Exportar Relatório de Taxa de Visualização',
        report_export: 'Relatório de exportação',
        related_announcements: 'Informações de anúncio relacionadas',
        related_announcements_notification: 'Notificação de anúncio relacionada',
        link_to_announcement: 'Anúncio',
        forwarding_records: 'Registos de encaminhamento',
        vehicle_condition: 'Condição do veículo',
        Extreme: 'Extremo',
        road_condition: 'Condição da estrada',
        climate: 'Clima',
        frequency: 'Frequência',
        organization_code: 'Código da organização',
        organization_name: 'Nome da organização',
        email_notification: 'Notificação por e-mail',
        required_are_mis: 'Campos obrigatórios estão faltando!',
        select_publish_Objects: 'Selecionar objeto de publicação',
        isPinned: 'estaFixado',
        deftem: 'Modelo padrão',
        newtempset: 'Novas Conf.',
        emailtemp: 'Temp. Email',
    },
    // 波兰
    plPL: {
        have: 'Posiadać',
        NoticeWaitingToBeRead: 'Oczekujące powiadomienia',
        title: 'Tytuł',
        publishing_department: 'Dział publikujący',
        status: 'Status',
        release_Date: 'Data publikacji',
        bulletin_id: 'Identyfikator biuletynu',
        publisher: 'Osoba publikująca',
        information_detail: 'Informacje szczegółowe',
        notification_Title: 'Tytuł powiadomienia',
        publish_Objects: 'Opublikowane do',
        publish_Mode: 'Tryb publikacji',
        publish_Content: 'Treść publikacji',
        bulletin_type: 'Typ biuletynu',
        viewing_rate_statements_export: 'Eksport Raportu Stopy Wyświetlania',
        report_export: 'Raport eksportu',
        related_announcements: 'Powiązane informacje o ogłoszeniach',
        related_announcements_notification: 'Powiązane powiadomienie o ogłoszeniu',
        link_to_announcement: 'Ogłoszenie',
        forwarding_records: 'Przekazywanie zapisów',
        vehicle_condition: 'Stan pojazdu',
        Extreme: 'Ekstremalny',
        road_condition: 'Stan drogi',
        climate: 'Klimat',
        frequency: 'Częstotliwość',
        organization_code: 'Kod organizacji',
        organization_name: 'Nazwa organizacji',
        email_notification: 'Powiadomienie e-mail',
        required_are_mis: 'Brakuje wymaganych pól!',
        select_publish_Objects: 'Wybierz obiekt publikacji',
        isPinned: 'jestPrzypiete',
        deftem: 'Domyślny szablon',
        newtempset: 'Nowe Ust.',
        emailtemp: 'Szab. Email',
    },
    // 土耳其
    trTR: {
        have: 'Evet.',
        NoticeWaitingToBeRead: 'Bekleyen bildirimler',
        title: 'Başlık',
        publishing_department: 'Yayım departmanı',
        status: 'Durum',
        release_Date: 'Yayınlama Tarihi',
        bulletin_id: 'Bülten numarası',
        publisher: 'Yayıncı',
        information_detail: 'Bilgi detayları',
        notification_Title: 'Bildirim başlığı',
        publish_Objects: 'Yayınla',
        publish_Mode: 'Yayınlama modu',
        publish_Content: 'Yayın içeriği',
        bulletin_type: 'Bülten tipi',
        viewing_rate_statements_export: 'Görüntüleme Oranı Raporunu Dışa Aktarma',
        report_export: 'Rapor İhracat',
        related_announcements: 'İlgili duyuru bilgileri',
        related_announcements_notification: 'İlgili duyuru bildirimi',
        link_to_announcement: 'Duyuru',
        forwarding_records: 'Kayıtları ilerleme',
        vehicle_condition: 'Araç Durumu',
        Extreme: 'Aşırı',
        road_condition: 'Yol Durumu',
        climate: 'İklim',
        frequency: 'Frekans',
        organization_code: 'Organizasyon CODE',
        organization_name: 'Organizasyon adı',
        email_notification: 'E-posta Bildirimi',
        required_are_mis: 'Zorunlu alanlar eksik!',
        select_publish_Objects: 'Yayın hedefini seç',
        isPinned: 'sabitMi',
        deftem: 'Varsayılan şablon',
        newtempset: 'Yeni Ayar',
        emailtemp: 'E-posta Şab.',
    },
    // 捷克语
    csCZ: {
        have: 'Mají',
        NoticeWaitingToBeRead: 'Oznámení čekající na přečtení',
        title: 'Název',
        publishing_department: 'Vydávání publikací',
        status: 'Status',
        release_Date: 'Datum vydání',
        bulletin_id: 'ID bulletinu',
        publisher: 'Vydavatel',
        information_detail: 'Detail informace',
        notification_Title: 'Název oznámení',
        publish_Objects: 'Uvolnění pro',
        publish_Mode: 'Režim vydání',
        publish_Content: 'Popis obsahu vydání',
        bulletin_type: 'Typ bulletinu',
        viewing_rate_statements_export: 'View Rate Report Export',
        report_export: 'report Export',
        related_announcements: 'Související oznámení',
        related_announcements_notification: 'Upozornění na související oznámení',
        link_to_announcement: 'Odkaz na oznámení',
        forwarding_records: 'Přeposílání záznamů',
        vehicle_condition: 'Stav vozidla',
        Extreme: 'Extrémní',
        road_condition: 'Stav silnice',
        climate: 'Podnebí',
        frequency: 'Frekvence',
        organization_code: 'Kód společnosti',
        organization_name: 'Název společnosti',
        email_notification: 'E-mailová notifikace',
        required_are_mis: 'Chybí povinné pole!',
        select_publish_Objects: 'Vyberte cíl publikace',
        isPinned: 'jePripnuto',
        deftem: 'Výchozí šablona',
        newtempset: 'Nové Nast.',
        emailtemp: 'Šabl. Email',
    },
    // 匈牙利语
    huHU: {
        have: 'Összesen',
        NoticeWaitingToBeRead: 'Olvasatlan értesítések',
        title: 'Cím',
        publishing_department: 'Közzétevő részleg',
        status: 'Állapot',
        release_Date: 'Kiadási dátum',
        bulletin_id: 'Hirdetményazonosító',
        publisher: 'Közzétevő',
        information_detail: 'Információ részlet',
        notification_Title: 'Értesítés címe',
        publish_Objects: 'Közzétéve itt:',
        publish_Mode: 'Közzétételi üzemmód',
        publish_Content: 'Közzétett tartalom',
        bulletin_type: 'Hirdetmény típusa',
        viewing_rate_statements_export: 'Megtekintés Osztályozás Kimutatás Exportálás',
        report_export: 'Kimutatás exportálása',
        related_announcements: 'Kapcsolódó bejelentések',
        related_announcements_notification: 'Kapcsolódó bejelentések értesítése',
        link_to_announcement: 'Hivatkozás a bejelentésekre',
        forwarding_records: 'Rekordok továbbítása',
        vehicle_condition: 'Járműállapot',
        Extreme: 'Szélsőséges',
        road_condition: 'Útviszonyok',
        climate: 'Klíma',
        frequency: 'Gyakoriság',
        organization_code: 'Szervezet kódja',
        organization_name: 'Szervezet neve',
        email_notification: 'E-mail értesítés',
        required_are_mis: 'Kötelező mezők hiányoznak!',
        select_publish_Objects: 'Válassza ki a közzétételi célt',
        isPinned: 'felFestítve',
        deftem: 'Alapértelmezett sablon',
        newtempset: 'Új Beáll.',
        emailtemp: 'Email Sabl.',
    },
    // 俄罗斯
    ruRU: {
        have: 'Есть',
        NoticeWaitingToBeRead: 'Уведомление ожидает прочтения',
        title: 'Заголовок',
        publishing_department: 'Отдел публикации',
        status: 'Статус',
        release_Date: 'Дата выпуска',
        bulletin_id: 'Идентификатор бюллетеня',
        publisher: 'Издатель',
        information_detail: 'Детали информации',
        notification_Title: 'Заголовок уведомления',
        publish_Objects: 'Опубликовать для',
        publish_Mode: 'Режим публикации',
        publish_Content: 'Содержание публикации',
        bulletin_type: 'Тип бюллетеня',
        viewing_rate_statements_export: 'Экспорт отчетов о просмотре',
        report_export: 'Экспорт отчета',
        related_announcements: 'Связанные объявления',
        related_announcements_notification: 'Уведомление о связанных объявлениях',
        link_to_announcement: 'Ссылка на объявление',
        forwarding_records: 'Записи о пересылке',
        vehicle_condition: 'Состояние автомобиля',
        Extreme: 'Экстремальные',
        road_condition: 'Состояние дороги',
        climate: 'Климат',
        frequency: 'Частота',
        organization_code: 'Код организации',
        organization_name: 'Название организации',
        email_notification: 'Уведомление по почте',
        required_are_mis: 'Отсутствуют обязательные поля!',
        select_publish_Objects: 'Выберите объект публикации',
        isPinned: 'zakrepleno',
        deftem: 'Шаблон по умолчанию',
        newtempset: 'Новые Настр.',
        emailtemp: 'Шаб. Email',
    },
    // 沙特阿拉伯
    arSA: {
        have: 'إجمالي',
        NoticeWaitingToBeRead: 'إشعار/إشعارات بانتظار القراءة',
        title: 'العنوان',
        publishing_department: 'قسم النشر',
        status: 'الحالة',
        release_Date: 'تاريخ النشر',
        bulletin_id: 'معرّف الإعلان',
        publisher: 'الناشر',
        information_detail: 'معلومات الإعلان',
        notification_Title: 'عنوان الإشعار',
        publish_Objects: 'أهداف النشر',
        publish_Mode: 'وضع النشر',
        publish_Content: 'محتوى النشر',
        bulletin_type: 'تصنيف الإعلان',
        viewing_rate_statements_export: 'تصدير تقرير معدل المشاهدة',
        report_export: 'تصدير التقرير',
        related_announcements: 'معلومات الإعلانات المرتبطة',
        related_announcements_notification: 'إشعار الإعلانات المرتبطة',
        link_to_announcement: 'رابط',
        forwarding_records: 'سجلات إعادة التوجيه',
        vehicle_condition: 'حالة المركبة',
        Extreme: 'شديد',
        road_condition: 'حالة الطريق',
        climate: 'المناخ',
        frequency: 'التكرار',
        organization_code: 'رمز المنظمة',
        organization_name: 'اسم المنظمة',
        email_notification: 'هل يتم إرسال إشعار بالبريد الإلكتروني؟',
        required_are_mis: 'يوجد حقول إلزامية غير معبأة!',
        select_publish_Objects: 'اختر أهداف النشر',
        isPinned: 'هل يتم تثبيته في الأعلى؟',
        deftem: 'القالب الافتراضي',
        newtempset: 'إعداد قالب جديد',
        emailtemp: 'قالب البريد الإلكتروني',
    },
    // 保加利亚
    bgBG: {
        have: 'Общо',
        NoticeWaitingToBeRead: 'известия за четене',
        title: 'Заглавие',
        publishing_department: 'Отдел за публикуване',
        status: 'Статус',
        release_Date: 'Дата на публикуване',
        bulletin_id: 'ID на съобщението',
        publisher: 'Публикувал',
        information_detail: 'Информация за съобщението',
        notification_Title: 'Заглавие на известие',
        publish_Objects: 'Целеви получатели',
        publish_Mode: 'Режим на публикуване',
        publish_Content: 'Съдържание',
        bulletin_type: 'Категория на съобщението',
        viewing_rate_statements_export: 'Експорт на отчет за процент прочитаност',
        report_export: 'Експорт на отчет',
        related_announcements: 'Свързана информация за съобщения',
        related_announcements_notification: 'Известие за свързани съобщения',
        link_to_announcement: 'Връзка',
        forwarding_records: 'Записи за препращане',
        vehicle_condition: 'Състояние на превозното средство',
        Extreme: 'Екстремно',
        road_condition: 'Състояние на пътя',
        climate: 'Климат',
        frequency: 'Честота',
        organization_code: 'Код на организацията',
        organization_name: 'Име на организацията',
        email_notification: 'Изпращане на имейл известие?',
        required_are_mis: 'Има задължителни полета, които не са попълнени!',
        select_publish_Objects: 'Изберете целеви получатели',
        isPinned: 'Закачено ли е отгоре?',
        deftem: 'Шаблон по подразбиране',
        newtempset: 'Настройки за нов шаблон',
        emailtemp: 'Имейл шаблон',
    },
    // 丹麦语
    daDK: {
        have: 'Totalt',
        NoticeWaitingToBeRead: 'ubedte notifikationer',
        title: 'Titel',
        publishing_department: 'Udgivende afdeling',
        status: 'Status',
        release_Date: 'Udgivelsesdato',
        bulletin_id: 'Meddelelses-ID',
        publisher: 'Udgiver',
        information_detail: 'Meddelelsesoplysninger',
        notification_Title: 'Notifikationstitel',
        publish_Objects: 'Modtagere',
        publish_Mode: 'Udgivelsestilstand',
        publish_Content: 'Udgivelsesindhold',
        bulletin_type: 'Meddelelseskategori',
        viewing_rate_statements_export: 'Eksport af visningsfrekvensrapport',
        report_export: 'Rapporteksport',
        related_announcements: 'Relaterede meddelelser',
        related_announcements_notification: 'Notifikation om relaterede meddelelser',
        link_to_announcement: 'Link',
        forwarding_records: 'Videresendelseslog',
        vehicle_condition: 'Køretøjsstand',
        Extreme: 'Ekstrem',
        road_condition: 'Vejforhold',
        climate: 'Klima',
        frequency: 'Hyppighed',
        organization_code: 'Organisationskode',
        organization_name: 'Organisationsnavn',
        email_notification: 'E-mail-notifikation aktiveret?',
        required_are_mis: 'Påkrævede felter mangler!',
        select_publish_Objects: 'Vælg modtagere',
        isPinned: 'Fastgjort øverst?',
        deftem: 'Standard skabelon',
        newtempset: 'Ny skabelonopsætning',
        emailtemp: 'E-mail-skabelon',
    },
    // 芬兰语
    fiFI: {
        have: 'Yhteensä',
        NoticeWaitingToBeRead: 'lukematonta ilmoitusta',
        title: 'Otsikko',
        publishing_department: 'Julkaisija (osasto)',
        status: 'Tila',
        release_Date: 'Julkaisupäivämäärä',
        bulletin_id: 'Ilmoituksen tunnus',
        publisher: 'Julkaisija',
        information_detail: 'Ilmoituksen tiedot',
        notification_Title: 'Ilmoituksen otsikko',
        publish_Objects: 'Julkaisukohteet',
        publish_Mode: 'Julkaisutila',
        publish_Content: 'Julkaisun sisältö',
        bulletin_type: 'Ilmoituksen luokka',
        viewing_rate_statements_export: 'Katseluprosenttiraportin vienti',
        report_export: 'Raportin vienti',
        related_announcements: 'Liittyvät ilmoitukset',
        related_announcements_notification: 'Ilmoitus liittyvistä ilmoituksista',
        link_to_announcement: 'Linkki',
        forwarding_records: 'Edelleenlähetysloki',
        vehicle_condition: 'Ajoneuvon kunto',
        Extreme: 'Äärimmäinen',
        road_condition: 'Tien kunto',
        climate: 'Ilmasto',
        frequency: 'Taajuus',
        organization_code: 'Organisaatiokoodi',
        organization_name: 'Organisaation nimi',
        email_notification: 'Sähköposti-ilmoitus käytössä?',
        required_are_mis: 'Pakollisia kenttiä puuttuu!',
        select_publish_Objects: 'Valitse julkaisukohteet',
        isPinned: 'Kiinnitetty ylös?',
        deftem: 'Oletusmalli',
        newtempset: 'Uuden mallin asetukset',
        emailtemp: 'Sähköpostimalli',
    },
    // 繁体中文台湾
    zhTW: {
        have: '共有',
        NoticeWaitingToBeRead: '則待閱通知',
        title: '標題',
        publishing_department: '發布部門',
        status: '狀態',
        release_Date: '發布日期',
        bulletin_id: '公告ID',
        publisher: '發布人',
        information_detail: '公告資訊',
        notification_Title: '通知標題',
        publish_Objects: '發布對象',
        publish_Mode: '發布模式',
        publish_Content: '發布內容',
        bulletin_type: '公告分類',
        viewing_rate_statements_export: '查看率報表匯出',
        report_export: '報表匯出',
        related_announcements: '關聯公告資訊',
        related_announcements_notification: '關聯公告通知',
        link_to_announcement: '連結',
        forwarding_records: '轉發記錄',
        vehicle_condition: '車況',
        Extreme: '極端',
        road_condition: '路況',
        climate: '氣候',
        frequency: '頻率',
        organization_code: '組織CODE',
        organization_name: '組織名稱',
        email_notification: '是否郵件通知',
        required_are_mis: '存在必填項未填！',
        select_publish_Objects: '選擇發布對象',
        isPinned: '是否置頂',
        deftem: '預設模板',
        newtempset: '新模板設定',
        emailtemp: '郵件模板',
    },
    // 克罗地亚
    hrHR: {
        have: 'Ukupno',
        NoticeWaitingToBeRead: 'obavijesti za čitanje',
        title: 'Naslov',
        publishing_department: 'Odjel za objavljivanje',
        status: 'Status',
        release_Date: 'Datum objave',
        bulletin_id: 'ID obavijesti',
        publisher: 'Objavio',
        information_detail: 'Detalji obavijesti',
        notification_Title: 'Naslov obavijesti',
        publish_Objects: 'Ciljne osobe',
        publish_Mode: 'Način objave',
        publish_Content: 'Sadržaj objave',
        bulletin_type: 'Kategorija obavijesti',
        viewing_rate_statements_export: 'Izvoz izvješća o stopi pregleda',
        report_export: 'Izvoz izvješća',
        related_announcements: 'Povezane obavijesti',
        related_announcements_notification: 'Obavijest o povezanim obavijestima',
        link_to_announcement: 'Poveznica',
        forwarding_records: 'Zapisi proslijeđivanja',
        vehicle_condition: 'Stanje vozila',
        Extreme: 'Ekstremno',
        road_condition: 'Stanje ceste',
        climate: 'Klima',
        frequency: 'Učestalost',
        organization_code: 'Šifra organizacije',
        organization_name: 'Naziv organizacije',
        email_notification: 'Obavijest e-poštom?',
        required_are_mis: 'Postoje obavezna polja koja nisu popunjena!',
        select_publish_Objects: 'Odaberite ciljne osobe',
        isPinned: 'Prikvačeno na vrh?',
        deftem: 'Zadani predložak',
        newtempset: 'Postavke novog predloška',
        emailtemp: 'Predložak e-pošte',
    },
    // 拉脱维亚
    lvLV: {
        have: 'Kopā',
        NoticeWaitingToBeRead: 'nelasītu paziņojumu',
        title: 'Nosaukums',
        publishing_department: 'Publicēšanas departaments',
        status: 'Statuss',
        release_Date: 'Publicēšanas datums',
        bulletin_id: 'Paziņojuma ID',
        publisher: 'Publicētājs',
        information_detail: 'Paziņojuma informācija',
        notification_Title: 'Paziņojuma nosaukums',
        publish_Objects: 'Publicēšanas mērķi',
        publish_Mode: 'Publicēšanas režīms',
        publish_Content: 'Publicējamais saturs',
        bulletin_type: 'Paziņojuma kategorija',
        viewing_rate_statements_export: 'Skatīšanās biežuma atskaites eksports',
        report_export: 'Atskaites eksports',
        related_announcements: 'Saistītie paziņojumi',
        related_announcements_notification: 'Paziņojums par saistītajiem paziņojumiem',
        link_to_announcement: 'Saite',
        forwarding_records: 'Pārsūtīšanas ieraksti',
        vehicle_condition: 'Transportlīdzekļa stāvoklis',
        Extreme: 'Ekstrēms',
        road_condition: 'Ceļa stāvoklis',
        climate: 'Klimats',
        frequency: 'Biežums',
        organization_code: 'Organizācijas kods',
        organization_name: 'Organizācijas nosaukums',
        email_notification: 'Vai sūtīt e-pasta paziņojumu?',
        required_are_mis: 'Trūkst obligāti aizpildāmo lauku!',
        select_publish_Objects: 'Atlasiet publicēšanas mērķus',
        isPinned: 'Vai piestiprināt augšā?',
        deftem: 'Noklusējuma veidne',
        newtempset: 'Jaunas veidnes iestatījumi',
        emailtemp: 'E-pasta veidne',
    },
    // 立陶宛
    ltLT: {
        have: 'Iš viso',
        NoticeWaitingToBeRead: 'pranešimų skaitymui',
        title: 'Antraštė',
        publishing_department: 'Publikavimo skyrius',
        status: 'Būsena',
        release_Date: 'Publikavimo data',
        bulletin_id: 'Pranešimo ID',
        publisher: 'Publikuotojas',
        information_detail: 'Pranešimo informacija',
        notification_Title: 'Pranešimo antraštė',
        publish_Objects: 'Publikavimo tikslai',
        publish_Mode: 'Publikavimo režimas',
        publish_Content: 'Publikuojamas turinys',
        bulletin_type: 'Pranešimo kategorija',
        viewing_rate_statements_export: 'Peržiūros dažnio ataskaitos eksportas',
        report_export: 'Ataskaitos eksportas',
        related_announcements: 'Susiję pranešimai',
        related_announcements_notification: 'Pranešimas apie susijusius pranešimus',
        link_to_announcement: 'Nuoroda',
        forwarding_records: 'Persiuntimo įrašai',
        vehicle_condition: 'Transporto priemonės būklė',
        Extreme: 'Ekstremalus',
        road_condition: 'Kelio būklė',
        climate: 'Klimatas',
        frequency: 'Dažnumas',
        organization_code: 'Organizacijos kodas',
        organization_name: 'Organizacijos pavadinimas',
        email_notification: 'Ar siųsti el. pašto pranešimą?',
        required_are_mis: 'Nepripildyti privalomi laukai!',
        select_publish_Objects: 'Pasirinkite publikavimo tikslus',
        isPinned: 'Ar pritvirtinti viršuje?',
        deftem: 'Numatytoji šablono',
        newtempset: 'Naujo šablono nustatymai',
        emailtemp: 'El. laiško šablonas',
    },
    // 罗马尼亚
    roRO: {
        have: 'Total',
        NoticeWaitingToBeRead: 'notificări de citit',
        title: 'Titlu',
        publishing_department: 'Departamentul de publicare',
        status: 'Stare',
        release_Date: 'Data publicării',
        bulletin_id: 'ID-ul buletinului',
        publisher: 'Publicat de',
        information_detail: 'Informații buletin',
        notification_Title: 'Titlul notificării',
        publish_Objects: 'Destinatari',
        publish_Mode: 'Mod de publicare',
        publish_Content: 'Conținut publicat',
        bulletin_type: 'Categorie buletin',
        viewing_rate_statements_export: 'Export raport rată vizualizare',
        report_export: 'Export raport',
        related_announcements: 'Anunțuri asociate',
        related_announcements_notification: 'Notificare anunțuri asociate',
        link_to_announcement: 'Link',
        forwarding_records: 'Istoric redirecționări',
        vehicle_condition: 'Starea vehiculului',
        Extreme: 'Extrem',
        road_condition: 'Starea drumului',
        climate: 'Climă',
        frequency: 'Frecvență',
        organization_code: 'Cod organizație',
        organization_name: 'Nume organizație',
        email_notification: 'Notificare prin e-mail?',
        required_are_mis: 'Există câmpuri obligatorii necompletate!',
        select_publish_Objects: 'Selectați destinatarii',
        isPinned: 'Fixat în top?',
        deftem: 'Șablon implicit',
        newtempset: 'Setări șablon nou',
        emailtemp: 'Șablon e-mail',
    },
    // 挪威博克马尔
    nbNO: {
        have: 'Totalt',
        NoticeWaitingToBeRead: 'uleste varsler',
        title: 'Tittel',
        publishing_department: 'Publiseringsavdeling',
        status: 'Status',
        release_Date: 'Publiseringsdato',
        bulletin_id: 'Varslings-ID',
        publisher: 'Utgiver',
        information_detail: 'Varslingsdetaljer',
        notification_Title: 'Varslingstittel',
        publish_Objects: 'Mottakere',
        publish_Mode: 'Publiseringsmodus',
        publish_Content: 'Publiseringsinnhold',
        bulletin_type: 'Varslingskategori',
        viewing_rate_statements_export: 'Eksport av visningsrate-rapport',
        report_export: 'Rapporteksport',
        related_announcements: 'Relaterte varsler',
        related_announcements_notification: 'Varsling om relaterte varsler',
        link_to_announcement: 'Lenke',
        forwarding_records: 'Videresendelseslogg',
        vehicle_condition: 'Kjøretøytilstand',
        Extreme: 'Ekstrem',
        road_condition: 'Vegforhold',
        climate: 'Klima',
        frequency: 'Frekvens',
        organization_code: 'Organisasjonskode',
        organization_name: 'Organisasjonsnavn',
        email_notification: 'E-postvarsling aktivert?',
        required_are_mis: 'Påkrevde felt mangler!',
        select_publish_Objects: 'Velg mottakere',
        isPinned: 'Festet øverst?',
        deftem: 'Standardmal',
        newtempset: 'Innstillinger for ny mal',
        emailtemp: 'E-postmal',
    },
    // 葡萄牙语巴西
    ptBX: {
        have: 'Total',
        NoticeWaitingToBeRead: 'notificações não lidas',
        title: 'Título',
        publishing_department: 'Departamento de Publicação',
        status: 'Status',
        release_Date: 'Data de Publicação',
        bulletin_id: 'ID do Aviso',
        publisher: 'Publicado por',
        information_detail: 'Detalhes do Aviso',
        notification_Title: 'Título da Notificação',
        publish_Objects: 'Destinatários',
        publish_Mode: 'Modo de Publicação',
        publish_Content: 'Conteúdo da Publicação',
        bulletin_type: 'Categoria do Aviso',
        viewing_rate_statements_export: 'Exportar relatório de taxa de visualização',
        report_export: 'Exportar relatório',
        related_announcements: 'Avisos relacionados',
        related_announcements_notification: 'Notificação de avisos relacionados',
        link_to_announcement: 'Link',
        forwarding_records: 'Registros de encaminhamento',
        vehicle_condition: 'Condição do veículo',
        Extreme: 'Extremo',
        road_condition: 'Condição da estrada',
        climate: 'Clima',
        frequency: 'Frequência',
        organization_code: 'Código da organização',
        organization_name: 'Nome da organização',
        email_notification: 'Notificação por e-mail ativada?',
        required_are_mis: 'Campos obrigatórios não preenchidos!',
        select_publish_Objects: 'Selecione os destinatários',
        isPinned: 'Fixado no topo?',
        deftem: 'Modelo padrão',
        newtempset: 'Configurações do novo modelo',
        emailtemp: 'Modelo de e-mail',
    },
    // 瑞典语
    svSE: {
        have: 'Totalt',
        NoticeWaitingToBeRead: 'olästa aviseringar',
        title: 'Titel',
        publishing_department: 'Publiceringsavdelning',
        status: 'Status',
        release_Date: 'Publiceringsdatum',
        bulletin_id: 'Meddelande-ID',
        publisher: 'Utgivare',
        information_detail: 'Meddelandedetaljer',
        notification_Title: 'Aviseringstitel',
        publish_Objects: 'Mottagare',
        publish_Mode: 'Publiceringsläge',
        publish_Content: 'Publiceringsinnehåll',
        bulletin_type: 'Meddelandekategori',
        viewing_rate_statements_export: 'Export av visningsfrekvensrapport',
        report_export: 'Rapportexport',
        related_announcements: 'Relaterade meddelanden',
        related_announcements_notification: 'Avisering om relaterade meddelanden',
        link_to_announcement: 'Länk',
        forwarding_records: 'Vidarebefordringslogg',
        vehicle_condition: 'Fordonsstatus',
        Extreme: 'Extrem',
        road_condition: 'Vägförhållanden',
        climate: 'Klimat',
        frequency: 'Frekvens',
        organization_code: 'Organisationskod',
        organization_name: 'Organisationsnamn',
        email_notification: 'E-postavisering aktiverad?',
        required_are_mis: 'Obligatoriska fält saknas!',
        select_publish_Objects: 'Välj mottagare',
        isPinned: 'Fastfäst överst?',
        deftem: 'Standardmall',
        newtempset: 'Inställningar för ny mall',
        emailtemp: 'E-postmall',
    },
    // 斯洛伐克
    skSK: {
        have: 'Celkom',
        NoticeWaitingToBeRead: 'nečítaných oznámení',
        title: 'Názov',
        publishing_department: 'Oddelenie pre zverejňovanie',
        status: 'Stav',
        release_Date: 'Dátum zverejnenia',
        bulletin_id: 'ID oznámenia',
        publisher: 'Zverejnil',
        information_detail: 'Detaily oznámenia',
        notification_Title: 'Názov oznámenia',
        publish_Objects: 'Cieľové skupiny',
        publish_Mode: 'Režim zverejnenia',
        publish_Content: 'Obsah zverejnenia',
        bulletin_type: 'Kategória oznámenia',
        viewing_rate_statements_export: 'Export správy o miere prezerania',
        report_export: 'Export správy',
        related_announcements: 'Súvisiace oznámenia',
        related_announcements_notification: 'Oznámenie o súvisiacich oznámeniach',
        link_to_announcement: 'Odkaz',
        forwarding_records: 'Záznamy o presmerovaní',
        vehicle_condition: 'Stav vozidla',
        Extreme: 'Extrémny',
        road_condition: 'Stav cesty',
        climate: 'Podnebie',
        frequency: 'Frekvencia',
        organization_code: 'Kód organizácie',
        organization_name: 'Názov organizácie',
        email_notification: 'Upozornenie e-mailom?',
        required_are_mis: 'Chýbajú povinné údaje!',
        select_publish_Objects: 'Vyberte cieľové skupiny',
        isPinned: 'Pripnuté hore?',
        deftem: 'Predvolená šablóna',
        newtempset: 'Nastavenia novej šablóny',
        emailtemp: 'E-mailová šablóna',
    },
    // 斯洛文尼亚
    slSI: {
        have: 'Skupaj',
        NoticeWaitingToBeRead: 'neprebranih obvestil',
        title: 'Naslov',
        publishing_department: 'Oddel za objavo',
        status: 'Status',
        release_Date: 'Datum objave',
        bulletin_id: 'ID obvestila',
        publisher: 'Objavil',
        information_detail: 'Podrobnosti obvestila',
        notification_Title: 'Naslov obvestila',
        publish_Objects: 'Ciljne skupine',
        publish_Mode: 'Način objave',
        publish_Content: 'Vsebina objave',
        bulletin_type: 'Kategorija obvestila',
        viewing_rate_statements_export: 'Izvoz poročila o stopnji ogledov',
        report_export: 'Izvoz poročila',
        related_announcements: 'Povezana obvestila',
        related_announcements_notification: 'Obvestilo o povezanih obvestilih',
        link_to_announcement: 'Povezava',
        forwarding_records: 'Zgodovina posredovanj',
        vehicle_condition: 'Stanje vozila',
        Extreme: 'Ekstremen',
        road_condition: 'Stanje ceste',
        climate: 'Podnebje',
        frequency: 'Pogostost',
        organization_code: 'Koda organizacije',
        organization_name: 'Ime organizacije',
        email_notification: 'Obvestilo po e-pošti?',
        required_are_mis: 'Manjkajo obvezni podatki!',
        select_publish_Objects: 'Izberite ciljne skupine',
        isPinned: 'Pripeto na vrh?',
        deftem: 'Privzeta predloga',
        newtempset: 'Nastavitve nove predloge',
        emailtemp: 'E-poštna predloga',
    },
    // 泰语
    thTH: {
        have: 'ทั้งหมด',
        NoticeWaitingToBeRead: 'รายการแจ้งเตือนที่ยังไม่อ่าน',
        title: 'หัวข้อ',
        publishing_department: 'หน่วยงานผู้ประกาศ',
        status: 'สถานะ',
        release_Date: 'วันที่ประกาศ',
        bulletin_id: 'รหัสประกาศ',
        publisher: 'ผู้ประกาศ',
        information_detail: 'รายละเอียดประกาศ',
        notification_Title: 'หัวข้อการแจ้งเตือน',
        publish_Objects: 'กลุ่มเป้าหมาย',
        publish_Mode: 'รูปแบบการประกาศ',
        publish_Content: 'เนื้อหาประกาศ',
        bulletin_type: 'ประเภทประกาศ',
        viewing_rate_statements_export: 'ส่งออกรายงานอัตราการอ่าน',
        report_export: 'ส่งออกรายงาน',
        related_announcements: 'ประกาศที่เกี่ยวข้อง',
        related_announcements_notification: 'แจ้งเตือนประกาศที่เกี่ยวข้อง',
        link_to_announcement: 'ลิงก์',
        forwarding_records: 'ประวัติการส่งต่อ',
        vehicle_condition: 'สภาพรถ',
        Extreme: 'รุนแรงมาก',
        road_condition: 'สภาพถนน',
        climate: 'สภาพภูมิอากาศ',
        frequency: 'ความถี่',
        organization_code: 'รหัสองค์กร',
        organization_name: 'ชื่อองค์กร',
        email_notification: 'แจ้งเตือนทางอีเมลหรือไม่',
        required_are_mis: 'มีช่องที่ต้องกรอกข้อมูลแต่ยังไม่ได้กรอก!',
        select_publish_Objects: 'เลือกกลุ่มเป้าหมาย',
        isPinned: 'ปักหมุดหรือไม่',
        deftem: 'เทมเพลตเริ่มต้น',
        newtempset: 'ตั้งค่าเทมเพลตใหม่',
        emailtemp: 'เทมเพลตอีเมล',
    },
    // 乌克兰语
    ukUA: {
        have: 'Всього',
        NoticeWaitingToBeRead: 'сповіщень до прочитання',
        title: 'Заголовок',
        publishing_department: 'Відділ публікації',
        status: 'Статус',
        release_Date: 'Дата публікації',
        bulletin_id: 'ID оголошення',
        publisher: 'Опублікував',
        information_detail: 'Інформація про оголошення',
        notification_Title: 'Заголовок сповіщення',
        publish_Objects: 'Цільові отримувачі',
        publish_Mode: 'Режим публікації',
        publish_Content: 'Вміст публікації',
        bulletin_type: 'Категорія оголошення',
        viewing_rate_statements_export: 'Експорт звіту про перегляди',
        report_export: 'Експорт звіту',
        related_announcements: 'Пов’язані оголошення',
        related_announcements_notification: 'Сповіщення про пов’язані оголошення',
        link_to_announcement: 'Посилання',
        forwarding_records: 'Журнал переадресації',
        vehicle_condition: 'Стан транспортного засобу',
        Extreme: 'Екстремальний',
        road_condition: 'Стан дороги',
        climate: 'Клімат',
        frequency: 'Частота',
        organization_code: 'Код організації',
        organization_name: 'Назва організації',
        email_notification: 'Надсилати email-сповіщення?',
        required_are_mis: 'Не заповнено обов’язкові поля!',
        select_publish_Objects: 'Виберіть цільових отримувачів',
        isPinned: 'Закріпити зверху?',
        deftem: 'Типовий шаблон',
        newtempset: 'Налаштування нового шаблону',
        emailtemp: 'Шаблон електронного листа',
    },
    // 希腊语
    elGR: {
        have: 'Σύνολο',
        NoticeWaitingToBeRead: 'ειδοποιήσεις προς ανάγνωση',
        title: 'Τίτλος',
        publishing_department: 'Τμήμα Δημοσίευσης',
        status: 'Κατάσταση',
        release_Date: 'Ημερομηνία Δημοσίευσης',
        bulletin_id: 'ID Ανακοίνωσης',
        publisher: 'Δημοσιευτής',
        information_detail: 'Λεπτομέρειες Ανακοίνωσης',
        notification_Title: 'Τίτλος Ειδοποίησης',
        publish_Objects: 'Αποδέκτες',
        publish_Mode: 'Λειτουργία Δημοσίευσης',
        publish_Content: 'Περιεχόμενο Δημοσίευσης',
        bulletin_type: 'Κατηγορία Ανακοίνωσης',
        viewing_rate_statements_export: 'Εξαγωγή Αναφοράς Ρυθμού Προβολής',
        report_export: 'Εξαγωγή Αναφοράς',
        related_announcements: 'Σχετικές Ανακοινώσεις',
        related_announcements_notification: 'Ειδοποίηση για Σχετικές Ανακοινώσεις',
        link_to_announcement: 'Σύνδεσμος',
        forwarding_records: 'Ιστορικό Προωθήσεων',
        vehicle_condition: 'Κατάσταση Οχήματος',
        Extreme: 'Ακραίος',
        road_condition: 'Κατάσταση Δρόμου',
        climate: 'Κλίμα',
        frequency: 'Συχνότητα',
        organization_code: 'Κωδικός Οργανισμού',
        organization_name: 'Όνομα Οργανισμού',
        email_notification: 'Ενεργοποίηση ειδοποίησης με email;',
        required_are_mis: 'Υπάρχουν υποχρεωτικά πεδία που δεν έχουν συμπληρωθεί!',
        select_publish_Objects: 'Επιλέξτε αποδέκτες',
        isPinned: 'Καρφιτσωμένο στην κορυφή;',
        deftem: 'Προεπιλεγμένο Πρότυπο',
        newtempset: 'Ρυθμίσεις Νέου Προτύπου',
        emailtemp: 'Πρότυπο Email',
    },
    // 爱沙尼亚
    etEE: {
        have: 'Kokku',
        NoticeWaitingToBeRead: 'lugemata teavitust',
        title: 'Pealkiri',
        publishing_department: 'Avaldamise osakond',
        status: 'Olek',
        release_Date: 'Avaldamise kuupäev',
        bulletin_id: 'Teate ID',
        publisher: 'Avaldanud',
        information_detail: 'Teate üksikasjad',
        notification_Title: 'Teavituse pealkiri',
        publish_Objects: 'Sihtgrupid',
        publish_Mode: 'Avaldamise režiim',
        publish_Content: 'Avaldatav sisu',
        bulletin_type: 'Teate kategooria',
        viewing_rate_statements_export: 'Vaatamissageduse aruande eksport',
        report_export: 'Aruande eksport',
        related_announcements: 'Seotud teated',
        related_announcements_notification: 'Teade seotud teadete kohta',
        link_to_announcement: 'Link',
        forwarding_records: 'Edastuslogi',
        vehicle_condition: 'Sõiduki seisund',
        Extreme: 'Ekstreemne',
        road_condition: 'Tee seisund',
        climate: 'Kliima',
        frequency: 'Sagedus',
        organization_code: 'Organisatsiooni kood',
        organization_name: 'Organisatsiooni nimi',
        email_notification: 'Kas saata meiliteavitust?',
        required_are_mis: 'Puuduvad kohustuslikud väljad!',
        select_publish_Objects: 'Vali sihtgrupid',
        isPinned: 'Kas kinnitada üles?',
        deftem: 'Vaikimisi mall',
        newtempset: 'Uue malli seaded',
        emailtemp: 'Meilimall',
    },
    // 哈萨克
    kkKZ: {
        have: 'Барлығы',
        NoticeWaitingToBeRead: 'оқылмаған хабарландыру',
        title: 'Тақырыбы',
        publishing_department: 'Баспа бөлімі',
        status: 'Мәртебесі',
        release_Date: 'Жарияланған күні',
        bulletin_id: 'Хабарландыру ID',
        publisher: 'Жариялаушы',
        information_detail: 'Хабарландыру ақпараты',
        notification_Title: 'Хабарландыру тақырыбы',
        publish_Objects: 'Жариялау объектілері',
        publish_Mode: 'Жариялау режимі',
        publish_Content: 'Жариялау мазмұны',
        bulletin_type: 'Хабарландыру санаты',
        viewing_rate_statements_export: 'Қарау жиілігі туралы есеп беруді экспорттау',
        report_export: 'Есеп беруді экспорттау',
        related_announcements: 'Байланысты хабарландырулар',
        related_announcements_notification: 'Байланысты хабарландырулар туралы хабарландыру',
        link_to_announcement: 'Сілтеме',
        forwarding_records: 'Алға жіберу жазбалары',
        vehicle_condition: 'Көлік жағдайы',
        Extreme: 'Экстремалды',
        road_condition: 'Жол жағдайы',
        climate: 'Климат',
        frequency: 'Жиілік',
        organization_code: 'Ұйым коды',
        organization_name: 'Ұйым атауы',
        email_notification: 'Email арқылы хабарландыру қосылған ба?',
        required_are_mis: 'Міндетті толтыру өрістері толтырылмаған!',
        select_publish_Objects: 'Жариялау объектілерін таңдаңыз',
        isPinned: 'Жоғарыда бекітілген бе?',
        deftem: 'Әдепкі үлгі',
        newtempset: 'Жаңа үлгі параметрлері',
        emailtemp: 'Email үлгісі',
    },
    // 希伯来语
    heIL: {
        have: 'סה״כ',
        NoticeWaitingToBeRead: 'התראות שלא נקראו',
        title: 'כותרת',
        publishing_department: 'מחלקת פרסום',
        status: 'סטטוס',
        release_Date: 'תאריך פרסום',
        bulletin_id: 'מזהה הודעה',
        publisher: 'מפרסם',
        information_detail: 'פרטי ההודעה',
        notification_Title: 'כותרת ההתראה',
        publish_Objects: 'יעדי פרסום',
        publish_Mode: 'מצב פרסום',
        publish_Content: 'תוכן הפרסום',
        bulletin_type: 'קטגוריית הודעה',
        viewing_rate_statements_export: 'ייצוא דוח שיעור תצוגה',
        report_export: 'ייצוא דוח',
        related_announcements: 'הודעות קשורות',
        related_announcements_notification: 'התראת הודעות קשורות',
        link_to_announcement: 'קישור',
        forwarding_records: 'רשומות העברה',
        vehicle_condition: 'מצב הרכב',
        Extreme: 'קיצוני',
        road_condition: 'מצב הדרך',
        climate: 'אקלים',
        frequency: 'תדירות',
        organization_code: 'קוד ארגון',
        organization_name: 'שם הארגון',
        email_notification: 'להפעיל התראת דוא״ל?',
        required_are_mis: 'ישנם שדות חובה שלא מולאו!',
        select_publish_Objects: 'בחר יעדי פרסום',
        isPinned: 'לנעץ בראש?',
        deftem: 'תבנית ברירת מחדל',
        newtempset: 'הגדרות תבנית חדשה',
        emailtemp: 'תבנית דוא״ל',
    },
};
